/**
 * @generated SignedSource<<6c5a7427b59554a177cd8139bab67f87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type localStateQuery$variables = Record<PropertyKey, never>;
export type localStateQuery$data = {
  readonly UrlConfig: {
    readonly __typename: "UrlConfig";
  } | null | undefined;
};
export type localStateQuery = {
  response: localStateQuery$data;
  variables: localStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlConfig",
        "kind": "LinkedField",
        "name": "UrlConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "localStateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "localStateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "242b72f659a6a67e146ee2ae4738a82b",
    "id": null,
    "metadata": {},
    "name": "localStateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eaad0541d03e58a8df031f1f92f0de33";

export default node;
